import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as updateConfigurationActions from '../../actions/updateConfigurationActions'
import * as configurationActions from "../../actions/configurationActions";
import { FooterWithRouter, DefaultFooterTitle } from './components/Footer'
import { View3D } from './components/View3D'
import { Documents } from './components/Documents'
import { Details } from './completion/Details'
import { PatternPicker } from './motif/PatternPicker'
import { MotifFacePicker } from './motif/MotifFacePicker'
import { PatternFabric } from './motif/PatternFabric'
import { OptionPanel } from './components/OptionPanel'
import { UndoRedo } from './components/UndoRedo'
import { formatFace } from '../../services/format.service'
import { typePattern, typeEngraving } from './components/Fabric'
import cn from 'classnames'
import * as _ from 'lodash'
import { getDesignTypeConfiguration } from '../../services/utils.service';
import { warnOnTooManyItems,isConfigRequested } from '../../services/configurationWarningChecks'
import { isSmartphone } from '../../services/domFunctions'
import { TranslationContext } from "../../context/TranslationContext";
import {getStore} from '../../store';
import {Steps} from "intro.js-react";
import {introIsAvailable} from "../helpers/introHelpers"

class ConfiguratorMotifComponent extends Component {
  constructor(props) {
    super(props);
    this.stepsRef = React.createRef();
    this.skipTutorialMotif = this.skipTutorialMotif.bind(this);
    window["skipTutorialMotif"] = this.skipTutorialMotif;
  }

  static contextType = TranslationContext;
  state = {
    selectedPattern: null,
    selectedObjects: [],
    drawing: false,
    stepsEnabled: true,
    initialStep: 0,
    steps: [],
    flagCloseTutorial: false
  }

  componentDidMount(){    
    this.initializeIconColor();
    // this.launchIntro(true);
  }

  onBeforeExit = (stepIndex) => {
    const nbSteps = this.state.steps.length - 1
    if (nbSteps !== -1 && this.state.flagCloseTutorial === false) {
      if (stepIndex !== nbSteps) {
        const stepsRef = this.stepsRef.current.introJs
        stepsRef.nextStep();
        return false;
      }
    }
  };

  onExit = () => {
    this.setState({ steps: [] });
  };

  toggleStepsInModal = (modal) => {
    this.setState({flagCloseTutorial: false});
    if (modal) { this.launchIntro(false, modal); }
  };

  toggleSteps = () => {
    this.setState({flagCloseTutorial: false});
    const { steps } = this.state;
    if (steps.length < 1) {
      this.launchIntro(false);
    } else {
      this.setState(prevState => ({ stepsEnabled: !prevState.stepsEnabled }));
    }
  };

  launchIntro = (loadEvent=false, modal=false) => {
    this.setState({flagCloseTutorial: false});
    const t = this.context;
    const { configIntro } = this.props;

    const intro = loadEvent
      ? modal ? configIntro.find(element => element.step === "pattern" && element.is_modal && element.modal == modal && element.views < 1) : configIntro.find(element => element.step === "pattern" && !element.is_modal && element.views < 1)
      : modal ? configIntro.find(element => element.step === "pattern" && element.is_modal && element.modal == modal) : configIntro.find(element => element.step === "pattern" && !element.is_modal)

    if (intro) {
      const data = intro.data.map(dataItem => {
        const lastSegment = dataItem.intro.split(".").pop();
        dataItem.intro = t(lastSegment);
        return dataItem;
      }).sort((a, b) => {
        return a.order - b.order;
      });

      const familyUser = getStore().getState().user
      const member_id = familyUser && familyUser.id ? familyUser.id : null
      // if (loadEvent && member_id) this.props.configActions.addReadOnboarding(member_id, intro.id);
      if (member_id) this.props.configActions.addReadOnboarding(member_id, intro.id);
      this.setState({ steps: data });
    }
  };

  skipTutorialMotif = () => {
    this.setState({flagCloseTutorial: true});
  };

  // Initialize icons for checkbox
  initializeIconColor () {
    const status = this.state.drawing;
    const root = document.documentElement;
    const color = (status === true) 
      ? getComputedStyle(root).getPropertyValue("--secondary2")
      : getComputedStyle(root).getPropertyValue("--secondary2-hover") 
    const encodedColor = encodeURIComponent(color);
    const styleTag = document.createElement("style");
    styleTag.textContent = `
      :root {
        --checked-granite-icon: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.37728 11.9219L5.4716 11.0162C4.97141 10.516 4.97141 9.70505 5.4716 9.20486L9.09432 5.58214C9.59451 5.08195 10.4055 5.08195 10.9057 5.58214L14.5284 9.20486C15.0286 9.70505 15.0286 10.516 14.5284 11.0162L13.6227 11.9219M6.37728 8.07942L5.4716 7.17374C4.97141 6.67355 4.97141 5.86258 5.4716 5.36238L9.09432 1.73966C9.59451 1.23947 10.4055 1.23947 10.9057 1.73966L14.5284 5.36238C15.0286 5.86258 15.0286 6.67355 14.5284 7.17374L13.6227 8.07942M5.4716 14.6389L9.09432 18.2617C9.59451 18.7619 10.4055 18.7619 10.9057 18.2617L14.5284 14.6389C15.0286 14.1387 15.0286 13.3278 14.5284 12.8276L10.9057 9.20486C10.4055 8.70467 9.59451 8.70467 9.09432 9.20486L5.4716 12.8276C4.97141 13.3278 4.97141 14.1387 5.4716 14.6389Z' stroke='${encodedColor}' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
        --unchecked-granite-icon: url("data:image/svg+xml,%3Csvg width='17.44165mm' height='18.5215mm' viewBox='0 0 17.44165 18.5215' version='1.1' id='svg5' xml:space='preserve' xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape' xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd' xmlns='http://www.w3.org/2000/svg' xmlns:svg='http://www.w3.org/2000/svg'%3E%3Csodipodi:namedview id='namedview7' pagecolor='%23ffffff' bordercolor='%23000000' borderopacity='0.25' inkscape:showpageshadow='2' inkscape:pageopacity='0.0' inkscape:pagecheckerboard='0' inkscape:deskcolor='%23d1d1d1' inkscape:document-units='mm' showgrid='false' /%3E%3Cdefs id='defs2' /%3E%3Cg inkscape:groupmode='layer' id='layer2' inkscape:label='granit' inkscape:export-filename='layer2.svg' inkscape:export-xdpi='96' inkscape:export-ydpi='96' transform='translate(-134.5972,-149.01777)'%3E%3Cpath id='path5099' style='color:%23000000;fill:${encodedColor};fill-opacity:1;stroke-linecap:round;stroke-linejoin:round;-inkscape-stroke:none' d='m 143.41399,149.01778 c -0.46317,0 -0.92699,0.17457 -1.27745,0.52503 l -3.67161,3.67419 c -0.70091,0.70091 -0.70091,1.85346 0,2.55437 l 0.66973,0.67024 -0.66973,0.6718 c -0.70093,0.70092 -0.70092,1.85188 0,2.55281 l 0.56069,0.56018 -0.56069,0.56068 c -0.70091,0.70091 -0.70091,1.85191 0,2.55282 l 0.28216,0.28267 0.71727,-0.71675 -0.28267,-0.28267 c -0.31345,-0.31345 -0.31345,-0.80586 0,-1.11931 l 0.91777,-0.91778 2.7559,-2.7559 c 0.31343,-0.3134 0.80588,-0.3134 1.11931,0 l 0.28216,0.28215 0.71727,-0.71623 -0.28267,-0.28267 c -0.70093,-0.70086 -1.85396,-0.70086 -2.55489,0 l -2.39417,2.39623 -0.56068,-0.56017 c -0.31343,-0.31344 -0.31343,-0.80589 0,-1.11931 l 3.67367,-3.67368 c 0.31344,-0.31344 0.80587,-0.31344 1.11931,0 l 2.11925,2.11925 0.71676,-0.71675 -2.11925,-2.11977 c -0.70093,-0.70092 -1.85397,-0.70092 -2.55489,0 l -2.28513,2.28565 -0.66972,-0.67231 c -0.31345,-0.31345 -0.31345,-0.80534 0,-1.11879 l 3.67367,-3.6742 c 0.31343,-0.31343 0.80587,-0.31343 1.11931,0 l 3.67368,3.6742 c 0.15498,0.15497 0.23289,0.35376 0.23461,0.55293 l 0.81287,-0.81287 c -0.0835,-0.1651 -0.19349,-0.31958 -0.33073,-0.45682 l -3.67367,-3.67419 c -0.35047,-0.35046 -0.81427,-0.52503 -1.27744,-0.52503 z m 5.16712,6.49159 -1.62677,1.62678 0.69401,0.69401 c 0.31342,0.31342 0.31342,0.80588 0,1.11931 l -0.56069,0.56017 -1.25367,-1.25367 -0.71623,0.71727 1.61075,1.61076 0.002,0.002 0.91777,0.91778 c 0.31344,0.31344 0.31344,0.80586 0,1.11931 l -3.67368,3.67368 c -0.31344,0.31344 -0.80587,0.31344 -1.11931,0 l -2.53111,-2.53112 -0.71675,0.71727 2.52904,2.5306 c 0.70092,0.70092 1.85396,0.70092 2.55489,0 l 3.67367,-3.67368 c 0.7009,-0.70091 0.7009,-1.85191 0,-2.55282 l -0.56017,-0.56068 0.56017,-0.56018 c 0.70092,-0.70093 0.70092,-1.85189 0,-2.55281 l -0.67179,-0.6718 0.67179,-0.67024 c 0.0816,-0.0816 0.15339,-0.16952 0.21601,-0.262 z' /%3E%3Cpath style='color:%23000000;fill:${encodedColor};fill-opacity:1;stroke:none;stroke-width:0.811248;stroke-linecap:round;stroke-linejoin:round;-inkscape-stroke:none' d='m 151.00031,149.73537 -16.22495,16.22496 a 0.60843569,0.60843574 0 0 0 0,0.86036 0.60843569,0.60843574 0 0 0 0.86036,0 l 16.22496,-16.22495 a 0.60843569,0.60843574 0 0 0 0,-0.86037 0.60843569,0.60843574 0 0 0 -0.86037,0 z' id='path5087' inkscape:label='line dark' /%3E%3C/g%3E%3C/svg%3E");
      }
    `;
    document.head.appendChild(styleTag);
  }

  componentDidUpdate(){
    this.initializeIconColor();
    this.toggleButtonsNavigationStyle();
  }

  toggleButtonsNavigationStyle() {
    const buttons = document.getElementsByClassName('button-navigation');
    if (this.state.selectedPattern || this.state.selectedObjects.length > 0) {
      for (let button of buttons) { button.classList.add('bottom58'); }
    } else {
      for (let button of buttons) { button.classList.remove('bottom58'); }
    }
  }

  componentWillMount() {
    // Permet d'afficher immédiatement un warning s'il y a trop
    // de motifs ou patterns en place.
    // Le check à la modification est fait dans les updateConfigurationActions.
    warnOnTooManyItems()
  }

  // onToggleView = () => {
  //   history
  //     .push(`/configuration/${this.props.configuration.reference}/motifs-gravures/${formatFaceToId(this.props.motifOpts.face, !this.props.motifOpts.drawing)}`);
  // };
  onToggleView = () => {
    this.setState({
      drawing: !this.state.drawing
    })
  }

  onSelectObjects = (selectedObjects) => {
    if (
      selectedObjects.length === 1 &&
      selectedObjects[0].type === typePattern &&
      !selectedObjects[0].imprint
    ) {
      this.setState({
        selectedPattern: _.find(this.props.patterns, {
          reference: selectedObjects[0].reference
        }),
        selectedObjects: selectedObjects || []
      })
    } else {
      this.setState({
        selectedPattern: null,
        selectedObjects: selectedObjects || []
      })
    }
  }

  onClickEngraving = (reservation) => {
    this.props.actions.addEngraving(
      this.props.user,
      this.props.motifOpts.face,
      reservation
    )
  }

  render() {
    const t = this.context;
    const { configuration, motifOpts } = this.props;
    let { faces } = this.props
    const designType = getDesignTypeConfiguration(configuration);
    const facesStore = getStore().getState().configurator.current.options.faces
    if (facesStore) {
      faces = facesStore
    }
    const faceMotifRef = motifOpts.face?.piece.reference
    const faceMotifProfile = motifOpts.face?.profile.reference
    let faceMotif = _.find(faces, face => (face.piece.reference === faceMotifRef && face.profile.reference === faceMotifProfile));
    if (!faceMotif && motifOpts.face?.piece.name === "Accessoire") {
      faceMotif = _.find(faces, face=> face.piece.index === motifOpts.face?.piece.index)
    }                         

    if (faceMotif) {
      motifOpts.face.zone = faceMotif.zone
    }                         
    const { stepsEnabled, initialStep, steps } = this.state;
    const options = {
      tooltipClass: "customTooltip",
      showButtons: false,
      exitOnOverlayClick: true,
      showBullets: true,
      keyboardNavigation: false,
      skipLabel: `
        <a href="#" class="close-intro" onclick='window[\"skipTutorialMotif\"]()'>
        <span>Quitter le didacticiel</span>
        <div class="close-intro-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22.5836 1.19444L1.19472 22.5833M22.5836 22.5833L1.19472 1.19444" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </a>`
    };

    // aucune face présélectionnée? prendre la face par défaut
    if (motifOpts && !motifOpts.face && faces) {
      motifOpts.face = _.find(faces, 'default')
    } else if(motifOpts && motifOpts.face && faces && !faces.find(faceopt => faceopt.piece.reference === motifOpts.face.piece.reference)) {
      motifOpts.face = _.find(faces, 'default')
    }

    // Certains monuments n'ont pas de face
    const faceName = motifOpts && motifOpts.face && formatFace(motifOpts.face)
    const hasPanel =
    this.state.selectedObjects.length &&
    _.some(this.state.selectedObjects, { type: typeEngraving })
    
    return (
      <div
        className={cn('ConfigurationPatternsEngravings', {
          HasPanel: hasPanel
        })}
      >
        {faceName ? (
          <PatternFabric
            face={motifOpts.face}
            drawing={this.state.drawing}
            onSelectObjects={this.onSelectObjects}
            onReady={() => this.setState({ fabricReady: true })}
            designType={designType}
          />
        ) : (
          <p className='Error NoHeadStoneError' dangerouslySetInnerHTML={{ __html: t("config3d_unavailableengravings_accessories") }}></p>
        )}

        {this.state.fabricReady ? (
          <>
          {steps.length > 0 && (
            <Steps
              ref={this.stepsRef}
              options={options}
              enabled={stepsEnabled}
              steps={steps}
              initialStep={initialStep}
              onBeforeExit={this.onBeforeExit}
              onExit={this.onExit}
            />
          )}
          <div className='left-buttons'>
            <div className="left-buttons-container">

              <div className="btn-wrapper">
                <PatternPicker
                  face={motifOpts.face}
                  drawing={this.state.drawing}
                  imprint={false}
                  selectedPattern={this.state.selectedPattern}
                  buttonClassName="btn-config-secondary config-button-background text-dark config-button-hover"
                  toggleSteps={this.toggleStepsInModal}
                  launchIntro={this.launchIntro}
                  madalName="PatternPicker"
                />
              </div>

              <div className="btn-wrapper">
                <div className="btn-config">
                  <button
                    className={`SquareButton btn-config-secondary config-button-background text-dark ${isConfigRequested(false) ? 'disabled' : 'config-button-hover'}`}
                    onClick={() => this.onClickEngraving(false)}
                    disabled={isConfigRequested(false)}
                  >
                    <span className={"patterns-icon icon icon-large"}></span>
                    <div>
                      { t("config3d_patternandengravings_button_engraving") || "Gravure" }
                    </div>
                  </button>
                </div>
              </div>

              <OptionPanel
                closeOnClickInside={true}
                className='AddReservationOptionPanel'
                buttonContent={ t("config3d_patternandengravings_button_reservation") || "Réserve" }
                buttonIcon="reserve-icon"
                buttonClassName="btn-config-secondary config-button-background text-dark config-button-hover"
                disabled={isConfigRequested(false)}
              >
                <PatternPicker
                  face={motifOpts.face}
                  drawing={this.state.drawing}
                  imprint={true}
                  showIcon={false}
                  toggleSteps={this.toggleStepsInModal}
                  launchIntro={this.launchIntro}
                  madalName="ReservePicker"
                />
                <button
                  className='OptionPanelSquareItem secondary2-hover'
                  onClick={() => this.onClickEngraving(true)}
                >
                  { t("config3d_patternandengravings_button_reservation_egraving") || "Gravure" }
                </button>
              </OptionPanel>

              <div className="btn-wrapper">
                <div className="btn-config">
                  <MotifFacePicker
                    face={motifOpts.face}
                    drawing={this.state.drawing}
                    buttonClassName="btn-config-secondary text-dark config-button-background config-button-hover"
                    toggleSteps={this.toggleStepsInModal}
                    launchIntro={this.launchIntro}
                    madalName="PatternFace"
                  />
                </div>
              </div>
              
              {/* <button
                className={`SquareButton SwitchRender ${isConfigRequested(false) && 'disabled'}`}
                disabled={isConfigRequested(false)}
                onClick={this.onToggleView}
              >
                Avec / sans rendu granit
              </button> */}

              <div className={`cfg-switch mb-5 ${isConfigRequested(false) ? 'disabled' : ''}`}>
                <label>
                  <input 
                    checked={!this.state.drawing} 
                    type="checkbox" 
                    disabled={isConfigRequested(false)} 
                    onChange={this.onToggleView} />
                  <span className="granite"></span>
                </label>
                <div className="text-content text-dark">
                  { t("config3d_actionbuttons_granittoggle") || "Granits" }
                </div>
              </div>

              {introIsAvailable("pattern") &&
                <div className='d-flex flex-column align-items-center'>
                  <span onClick={() => this.toggleSteps()} className="open-tutorial question-circle-icon icon icon-large mb-2"></span>
                  <span className="info-tutorial text-dark ">visite guidée de la page</span>
                </div>
              }
            </div>
          </div>
          </>
        ) : faceName ? (
          <div className='fabricSpinner' />
        ) : null}

        {!isSmartphone() && (
        <div className='right-buttons'>
          <div className="right-buttons-container">
            <View3D />
            <Documents />
            <Details />
            <UndoRedo />
          </div>
        </div>
        )}

        <FooterWithRouter footerLinks={this.props.footerLinks}>
          <DefaultFooterTitle configuration={configuration} />
          <p className='Face'>{faceName || '-'}</p>
          {isSmartphone() && (
            <div className="d-flex justify-content-around">
              <View3D />
              <Documents />
              <Details />
            </div>
          )}
        </FooterWithRouter>
      </div>
    )
  }
}

export const ConfiguratorMotif = connect(
  (state) => ({
    configuration: state.configurator.current.configuration,
    faces: state.configurator.current.options.faces,
    patterns: state.configurator.current.patterns,
    user: state.user,
    configIntro: state.configurator.configIntro,
  }),
  (dispatch) => ({
    actions: bindActionCreators(updateConfigurationActions, dispatch),
    configActions: bindActionCreators(configurationActions, dispatch),
  })
)(ConfiguratorMotifComponent)
